<template>
    <div class="FormResetZafiro">
        <div v-if="FormResetZafiro">
            <div class="container container-form">
                <div class="row">
                    <div class="col-md-7 totalform motBusUser">  
                        <div v-if="infoData" class="alert alert-danger">
                            <p>
                                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoCorrect" class="alert alert-success">
                            <p>
                                Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso y será atendido lo más pronto posible.
                            </p>
                        </div>
                        <h1 class="titleForm"><strong>¿Has olvidado tu clave? ¡No te preocupes!</strong></h1>
                        <p class="descriptionForm">
                            Diligencia el formulario que encontrarás a continuación y recibirás un correo electrónico con una nueva contraseña para ingresar a Zafiro. 
                            Tendrás respuesta de tu solicitud dentro de 15 minutos a partir del diligenciamiento del formulario. 
                            Utilizaremos el resto de tu información para actualizar tus datos y asegurarnos de siempre estar en contacto.
                        </p>
                        <ValidationObserver ref="obsformResetZafiro">
                            <FormResetZafiro :FieldsForm="formResetZafiro" :ModelForm="formInsModel" :method="executeProcess" />                                     
                        </ValidationObserver>
                        <div class="botoPnrocess">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="onComplete"
                                            class="loginbtn">
                                            Enviar
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="col-md-5 infoForm">
                        <FormDataInscription /> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataInscription from '@/views/InfoZone/FormResetZafiro.vue'
    import FormResetZafiro from '@/components/Forms.vue'
    import IberoHelpers from '@/store/helpers.js'

    export default{
        name: "FormResetedZafiro",
        components: {
            FormDataInscription,
            FormResetZafiro,
        },
        methods:{
            dataObjCheck: function(InfDaT){
                if(InfDaT === true){
                    return this.$ml.get('Accepted');   
                }
                return this.$ml.get('NotAccepted');    
                },
            loadFindData: function(restJson){
                debugger
                document.getElementById("IdNombres").readOnly = true;
                document.getElementById("IdApellidos").readOnly = true;
                document.getElementById("IdBanner").readOnly = true;
                document.getElementById("IdSendType").readOnly = true;
                this.formInsModel.IdNombres = restJson.Nombres
                this.formInsModel.IdApellidos = restJson.Apellidos
                this.formInsModel.IdBanner = restJson.IdBanner
                this.formInsModel.IdCellphone = restJson.Celular
                this.formInsModel.IdIberoMail = restJson.EmailInstitucional
            },
            clearFields: function(){
                document.getElementById("IdNombres").readOnly = false;
                document.getElementById("IdApellidos").readOnly = false;
                document.getElementById("IdBanner").readOnly = false;
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdCellphone = ''
                this.formInsModel.IdIberoMail = ''
            },
            dataformat: function(InfDaT){
                return IberoHelpers.dataObjDate(InfDaT);
            },
            dataObjFindJs: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjFind(infoDaT,FinDaT);
            },
            dataObjAllFind: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
            },
            executeProcess: function (event){
                switch (event.target.id){
                    case "IdDocumentType":
                        this.formInsModel.IdDocument = '';
                    break; 
                    case "IdDocument":
                        if(event.type === 'blur' && this.formInsModel.IdDocumentType !== '' && this.formInsModel.IdDocument !== ''){       
                        debugger
                        var pruebaUser = IberoHelpers.findStudentZafiro(this.$store, this.formInsModel);
                        pruebaUser.then(Response => {
                            debugger
                            if (Response.data !== '') {            
                                this.infoData = false;
                                this.loadFindData(Response.data)
                            }
                            else
                            {
                                this.clearFields()
                                this.infoData = true;
                            }
                        })
                        }
                    break;  
                }
            },
            UpdateUser: function() {
                debugger
                return new Promise((resolve, reject) => {
                    this.$refs.obsformResetZafiro.validate().then(results => {     
                        debugger   
                        if (!results) {
                            IberoHelpers.scrollToTop(0,500);
                            resolve(false)
                        }else{
                            this.FormResetZafiro = false;
                            resolve(true)
                        }
                    });
                });
            },
            goBackForm: function(){
                debugger
                this.FormResetZafiro = true;
                this.formInsModel.IdDocumentType = ''
                this.formInsModel.IdDocument = ''
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdCellphone = ''
                this.formInsModel.IdIberoMail = ''
            },
            onComplete(){
                debugger
                return new Promise((resolve, reject) => {
                    let loader = this.$loading.show();
                    var resultService = IberoHelpers.sendCaseResetPassZafiro(this.$store,this.formInsModel);
                    resultService.then(Response =>{
                        debugger
                        if (Response.data.status === '200'){
                            IberoHelpers.scrollToTop(0,100);
                            resolve(true);
                            loader.hide();
                            this.goBackForm();
                            this.infoCorrect = true;
                        }
                        else
                        {
                            resolve(false);
                            loader.hide();
                            IberoHelpers.scrollToTop(0,100);
                            this.dangerData = true;
                        }
                        
                    });
                });
                /*return new Promise((resolve, reject) => {
                    this.$refs.obsformResetZafiro.validate().then(results => {     
                        debugger   
                        if (!results) {
                            IberoHelpers.scrollToTop(0,500);
                            resolve(false)
                        }else{
                            let loader = this.$loading.show();
                            var resultService = IberoHelpers.sendCaseResetPassZafiro(this.$store,this.formInsModel);
                            resultService.then(Response =>{
                                debugger
                                if (!(Response === false)){
                                    if (Response.data.status === '200'){
                                        loader.hide();
                                        IberoHelpers.scrollToTop(0,500);
                                    }
                                }
                            });
                        }
                    });
                });*/
            },
        },
        data(){
            return {
                FormResetZafiro: true,
                infoData: false,
                infoCorrect: false,
                dangerData: false,
                sumaryData: [],
                NamePerson: [],
                LastnamePerson: [],
                IdType: [],
                Identification: [],
                formInsModel:{
                    Campaign: this.$route.params.referencia,
                    IdDocumentType: '',
                    IdDocument: '',
                    IdNombres: '',
                    IdApellidos: '',
                    IdBanner: '',
                    IdCellphone: '',
                    IdIberoMail: '',
                    IdObservation: '',
                },
                formResetZafiro:[
                    {            
                        id: 'IdDocumentType',
                        model: 'IdDocumentType',
                        //name: 'Tipo de Documento',
                        type: 'Select',  
                        placeholder: "Tipo de Documento",
                        values: this.$store.state.DocTypesList,
                        validate: {              
                            required: true              
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdDocument',
                        model: 'IdDocument',
                        //name: 'Documento de Identidad',
                        type: 'input',  
                        placeholder: 'Documento de Identidad',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdNombres',
                        model: 'IdNombres',
                        //name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Nombres',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                        required: true, 
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdApellidos',
                        model: 'IdApellidos',
                        //name: 'Apellidos',
                        type: 'input',  
                        placeholder: 'Apellidos',
                        values: '',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'IdBanner',
                        model: 'IdBanner',
                        //name: 'Código Estudiantil',
                        type: 'input',  
                        placeholder: 'Código Estudiantil',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'IdCellphone',
                        model: 'IdCellphone',
                        //name: 'Teléfono Celular',
                        type: 'input',  
                        placeholder: 'Teléfono Celular',
                        values: '',
                        validate: {
                        required: true, 
                        numeric: true,
                        max: 10,
                        min: 8 
                        },  
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'IdIberoMail',
                        model: 'IdIberoMail',
                        //name: 'Correo Institucional',
                        type: 'input',  
                        placeholder: 'Correo Institucional',
                        values: '',
                        validate: {
                        required: true, 
                        email: true 
                        },
                        class: 'col-md-6'               
                    },
                    {
                        id: 'IdSendType',
                        model: 'IdSendType',
                        //name: 'Tipo de Envío',
                        type: 'input',  
                        readonly:'isReadOnly',
                        placeholder: "INGRESO A ZAFIRO",
                        validate: {              
                        required: false              
                        },
                        class: 'col-md-12',
                    },  
                    {            
                        id: 'IdObservation',
                        model: 'IdObservation',
                        //name: 'Mensaje',
                        type: 'textarea',
                        hint: "Max 500 caracteres",
                        max: 500,
                        placeholder: 'Mensaje',
                        rows: 5,
                        values: '',
                        validate: 
                        {
                            required: false, 
                        },
                        class: 'col-md-12',
                        styleClasses: 'height: 200px'            
                    }, 
                ]
            }
        }
    }
</script>

<style scope>
.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 10px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.titleRef {
    font-weight: bold;
    padding-bottom: 0px;
    margin-top: 20px;
}

.titleForm {
    color: #222;
}

.descriptionForm {
    padding: 10px 10px 0px 10px;
    font-size: 12px;
    margin: 0px;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #fff;
    background:  #fff !important;       
    margin-bottom: 5px;
}

.container-form{
    padding: 30px 0;
    box-sizing: border-box;
}

.motBusUser{
    padding: 10px 10px 0px 10px;
    border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    margin: 10px auto;
    -webkit-border-radius: 5px 5px 5px 5px;
    background:  #fff !important;
}

body {
    background:  #fff !important;
}
header {
    background:  #fff !important;
}

.table > tbody > tr > td {
    vertical-align: middle !important;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
    color: #222;
}

.active
{
    color: #222;
}

#IdObservation {
    height: 90px;
}

.botoPnrocess {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 10px;
}
button:hover {
    background-color: #222;
    color: #fff;
}
.loginbtn {
    width: 90%;
    background-color: #fff;
    color: #222;
    border: #222 solid 3px;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
}

.validateBtn{
    width: 90%;
    border-color: #222;
    background-color: #fff;
    color: #222;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
    margin: 0px 10px 10px 10px;
}

/* Modal validación de datos */
.InscFiles{
    margin: 20px;
}

/* Grid validación data */
.wrapper {
    display: grid;
    margin: 10px 10px 10px 10px;
    padding: 1px 1px 1px 1px;
    grid-template-columns: repeat(2, 1fr);
    border: 1px solid black;
    grid-gap: 1px;
    background-color: black;
}

.wrapper > div {
    background-color: white;
    padding: 10px;
    text-align: center;
}

</style>